import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '../../utils/mui';
// necessary to support sx props
const ImageStyled = styled('img')({});
export function Image({ src, alt, width, height, className, sx }) {
    if (typeof src !== 'string') {
        throw new Error('Generic image component can not handle static object imports as source');
    }
    return (_jsx(ImageStyled, { className: className, src: src, alt: alt, width: width, height: height, sx: sx }));
}
